"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourPathToGrowth() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225835" id="your-path-to-growth" className="relative overflow-hidden bg-background text-foreground py-20 lg:py-32">
      {}
      <div className="pointer-events-none absolute top-0 left-0 h-full w-full opacity-40 mix-blend-multiply">
        <div className="absolute -top-40 -left-40 h-96 w-96 rounded-lg bg-primary/5 blur-3xl"></div>
        <div className="absolute top-1/2 right-0 h-80 w-80 -translate-y-1/2 translate-x-1/3 rounded-lg bg-secondary/5 blur-3xl"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center gap-16 lg:flex-row lg:gap-20">
          
          {}
          <div ref={textRef} className={`flex-1 lg:w-3/5 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="font-default text-5xl font-bold leading-[1.1] tracking-tight text-foreground md:text-6xl lg:text-7xl">
              10x Your Project{" "}
              <span className="text-primary">Capacity</span>
            </h1>
            
            <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed text-muted-foreground md:text-xl">
              Build faster with less labor. Join the ClifRock installer network and transform your outdoor living business with our panel masonry system.
            </p>
            
            <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 w-full rounded-lg px-8 text-base font-semibold shadow-lg transition-transform hover:-translate-y-1 sm:w-auto bg-primary text-primary-foreground">
                <Link to="/ApplyNowPage">Become a ClifRock Installer</Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="h-14 w-full rounded-lg px-8 text-base font-semibold text-foreground hover:bg-accent sm:w-auto border border-border">
                <Link to="/WhyClifRockPage">View Success Stories</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative w-full max-w-md lg:w-2/5 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="absolute inset-0 scale-105 rounded-lg bg-primary/10 mix-blend-multiply transition-transform duration-700 hover:rotate-2"></div>
            
            {}
            <div className="relative aspect-[4/5] overflow-hidden rounded-lg border-8 border-background shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_outdoor_kitchen_hero.png" alt="Profitable ClifRock outdoor living project installation" className="h-full w-full object-cover object-center transition-transform duration-1000 hover:scale-105" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}